import axios from "axios";
//import { authHeaderJson } from "../auth-header.service";
import { __CONTRACT_MODALITY } from "../../common/Dictionaries";


const getListContractModalitys = () => {
    return __CONTRACT_MODALITY
};

export {
    getListContractModalitys,
}